// Simulated code email (prototype only). Stands in for the real transactional
// email so the flow is demonstrable. It documents one real requirement: the
// code goes in the subject line.
export function EmailToast({ code }: { code: string }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 12,
        left: 0,
        right: 0,
        zIndex: 60,
        display: 'flex',
        justifyContent: 'center',
        padding: '0 12px',
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          background: 'rgba(240,250,251,0.96)',
          color: 'var(--deep)',
          borderRadius: 16,
          padding: '14px 16px',
          boxShadow: '0 18px 40px rgba(0,0,0,0.35)',
          animation: 'wh-slidein 360ms cubic-bezier(0.22,1,0.36,1)',
          backdropFilter: 'blur(12px)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontFamily: 'var(--font-mono)',
            fontSize: 11,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#5A7A80',
          }}
        >
          <span>mail · now</span>
          <span>prototype: this is the email</span>
        </div>
        <div style={{ fontSize: 19, fontWeight: 700, letterSpacing: '-0.015em', marginTop: 6 }}>
          {code} is your water hazard code
        </div>
        <div style={{ fontSize: 15, color: '#3E6068', marginTop: 2 }}>
          good for 20 minutes. type it on the page you're already on.
        </div>
      </div>
    </div>
  );
}
